/**
 * Common nurse/employee label: "Name (EmpID)".
 * Use everywhere emp names appear (hierarchy, history, agent lists).
 */
export const formatEmpDisplayName = (name, empId, fallback = '-') => {
    const displayName = String(name || '').trim();
    const id = empId != null ? String(empId).trim() : '';
    if (displayName && id) {
        return `${displayName} (${id})`;
    }
    if (displayName) {
        return displayName;
    }
    if (id) {
        return `(${id})`;
    }
    return fallback;
};

export const getEmpId = (source) => {
    if (!source) {
        return '';
    }
    const raw = source.empId ?? source.emp_id ?? source.EmpId ?? '';
    return raw != null ? String(raw).trim() : '';
};

export default formatEmpDisplayName;
